import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IOvEntry } from "../models/overage";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 */

export const GetOverageEntryDetailsAPI = async (osdNumber: number | string): Promise<IOvEntry> => {
  try {
    const response = await axios.get<any>(`${getUrl(ApiType.OVERAGE_ENTRY_DETAILS)}/${osdNumber}`);
    return response.data;
  } catch (error) {
    return throwApiError(error, ErrorMessages.overageEntryDetailsAPIError, { badRequestOrder: "errorsFirst" });
  }
};
